export default __webpack_public_path__ + "static/tablet_KV10-d3ed98c47047212c1a04a536a75b4132.mp4";